import { roughSizeOfObject } from '@verdant-web/common';
export function isAbortError(err) {
    return err instanceof Error && err.name === 'AbortError';
}
export function storeRequestPromise(request) {
    return new Promise((resolve, reject) => {
        request.onsuccess = () => {
            resolve(request.result);
        };
        request.onerror = () => {
            if (request.error && isAbortError(request.error)) {
                // TODO: is this the right thing to do?
                resolve(request.result);
            }
            else {
                reject(request.error);
            }
        };
    });
}
export function cursorIterator(request, callback) {
    return new Promise((resolve, reject) => {
        request.onsuccess = () => {
            const cursor = request.result;
            if (cursor) {
                if (callback(cursor.value)) {
                    cursor.continue();
                }
                else {
                    resolve();
                }
            }
            else {
                resolve();
            }
        };
        request.onerror = () => {
            if (request.error && isAbortError(request.error)) {
                resolve();
            }
            else {
                reject(request.error);
            }
        };
    });
}
export function getSizeOfObjectStore(database, storeName) {
    return new Promise((resolve, reject) => {
        const tx = database.transaction([storeName], 'readonly');
        const store = tx.objectStore(storeName);
        const cursorReq = store.openCursor();
        let count = 0;
        let size = 0;
        cursorReq.onsuccess = function (e) {
            const cursor = cursorReq.result;
            if (cursor) {
                count++;
                size = size + roughSizeOfObject(cursor.value);
                cursor.continue();
            }
        };
        cursorReq.onerror = function (e) {
            if (cursorReq.error && isAbortError(cursorReq.error)) {
                resolve({
                    count: count,
                    size: size,
                });
            }
            else {
                reject(cursorReq.error);
            }
        };
        tx.oncomplete = function (e) {
            resolve({
                count: count,
                size: size,
            });
        };
        tx.onabort = function (e) {
            reject(e);
        };
        tx.onerror = function (e) {
            reject(e);
        };
    });
}
export function getAllFromObjectStores(db, stores) {
    const transaction = db.transaction(stores, 'readonly');
    const promises = stores.map((store) => {
        const objectStore = transaction.objectStore(store);
        return storeRequestPromise(objectStore.getAll());
    });
    return Promise.all(promises);
}
export async function closeDatabase(db) {
    db.close();
    // wait for microtask queue to clear
    await new Promise((resolve, reject) => {
        resolve();
    });
}
export async function deleteAllDatabases(namespace, indexedDB = window.indexedDB) {
    const req1 = indexedDB.deleteDatabase([namespace, 'meta'].join('_'));
    const req2 = indexedDB.deleteDatabase([namespace, 'collections'].join('_'));
    await Promise.all([
        new Promise((resolve, reject) => {
            req1.onsuccess = resolve;
            req1.onerror = reject;
        }),
        new Promise((resolve, reject) => {
            req2.onsuccess = resolve;
            req2.onerror = reject;
        }),
    ]);
    window.location.reload();
}
export function deleteDatabase(name, indexedDB = window.indexedDB) {
    return storeRequestPromise(indexedDB.deleteDatabase(name));
}
export async function getAllDatabaseNamesAndVersions(indexedDB = window.indexedDB) {
    return indexedDB.databases();
}
export function createAbortableTransaction(db, storeNames, mode, abortSignal, log) {
    const tx = db.transaction(storeNames, mode);
    if (abortSignal) {
        const abort = () => {
            log === null || log === void 0 ? void 0 : log('debug', 'aborting transaction');
            try {
                tx.abort();
            }
            catch (e) {
                log === null || log === void 0 ? void 0 : log('debug', 'aborting transaction failed', e);
            }
        };
        abortSignal.addEventListener('abort', abort);
        tx.addEventListener('error', () => {
            abortSignal.removeEventListener('abort', abort);
        });
        tx.addEventListener('complete', () => {
            abortSignal.removeEventListener('abort', abort);
        });
    }
    return tx;
}
//# sourceMappingURL=idb.js.map